import React, { useEffect } from 'react';
import { Layer, Rect, Text, Transformer } from "react-konva";
import * as d3 from 'd3';

export default function Grid(props) {
  const trRef = React.useRef();
  const shapeRef = React.useRef();
  const [gridResults, setGridResults] = React.useState([]);
  useEffect(() => {
    if (props.selected && trRef.current && shapeRef.current) {
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    } else if (trRef.current) {
      trRef.current.nodes([]);
    }
  }, [props.selected]);

  useEffect(() => {
    console.log("useEffect in grid", props.areaResults);
    if (!props.areaResults || props.areaResults.length === 0) {
      setGridResults([]);
      return;
    }
    for (var i = 0; i < props.areaResults.length; i++) {
      var item = props.areaResults[i];
      if (item.calcResults?.outdoorResults[0]?.gridId == props.i) {
        setGridResults(item.calcResults?.outdoorResults[0]?.contourResults);
        break;
      }
    }
  }, [props.areaResults])


  const drawResults = (ctx) => {
    if (gridResults && gridResults.length > 0) {
      

      const grid = props.grid;
      var width = grid.origin.x.length;
      var height = grid.origin.y.length;

      ctx.font = "0.5px Arial";
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      var xPoints = Math.floor(width / grid.xSpacing);
      var yPoints = Math.floor(height / grid.ySpacing);

      if (xPoints * grid.xSpacing > width) xPoints--;
      if (yPoints * grid.ySpacing > height) yPoints--;

      var dataMax = Math.max(...gridResults);
      var dataMin = 1;

      var heightScale = height / yPoints;
      var widthScale = width / xPoints;

      // ctx.strokeStyle = "#aaa";
      ctx.strokeStyle = "transparent";
      ctx.lineWidth = 0.2;

      for (let x = 0; x < xPoints; x++) {
        let xPos = props.gridScaleX * x * widthScale;
        ctx.beginPath();
        ctx.moveTo(xPos, 0);
        ctx.lineTo(xPos, height);
        ctx.stroke();
      }

      for (let y = 0; y < yPoints; y++) {
        let yPos = props.gridScaleY * y * heightScale;
        ctx.beginPath();
        ctx.moveTo(0, yPos);
        ctx.lineTo(width, yPos);
        ctx.stroke();
      }

      var point = 0;
      if (props.grid.edgeStart) 
      {
        yPoints++;
        xPoints++;
      }

      for (let y = 0; y < yPoints; y++) {
        for (let x = 0; x < xPoints; x++) {
          if (point >= gridResults.length) break;

          let value = gridResults[point];
          if (value === undefined || value === null) {
            point++;
            continue;
          }

          if (gridResults[point] == dataMax) ctx.fillStyle = 'darkgreen';
          else if (gridResults[point] < dataMin) ctx.fillStyle = 'red';
          else ctx.fillStyle = 'cyan';

          let centerX, centerY;

          if (props.grid.edgeStart) {
            centerX = x * widthScale;
            centerY = y * heightScale;
          } else {
            centerX = (x * widthScale) + (widthScale / 2);
            centerY = (y * heightScale) + (heightScale / 2);
          }

          ctx.fillText(
            value,
            props.gridScaleX * centerX,
            props.gridScaleY * centerY
          );

          point++;
        }
      }
    }
  }



  const getDynamicFontSize = () => {
    return Math.max(1.5, 18 / props.stageScale);
  };

  const getTextPosition = () => {
    const fontOffset = getDynamicFontSize() + 0.5;

    if (!shapeRef.current) return { x: 0, y: 0 };

    const node = shapeRef.current;
    const nodeX = node.x();
    const nodeY = node.y();

    return {
      x: nodeX,
      y: nodeY - fontOffset,
    };
  };


  return props.grid.id !== 0 ? (
    <Layer key={props.i}>

      {props.grid.name && props.grid.visible && (
        <Text
          text={props.grid.name}
          x={getTextPosition().x}
          y={getTextPosition().y}
          align="center"
          fontSize={getDynamicFontSize()}
          fontStyle="bold"
          fill="black"
        />
      )}

      <Rect
        sceneFunc={props.showResults ? (ctx) => drawResults(ctx) : undefined}
        ref={shapeRef}
        fill={"transparent"}
        x={props.grid.origin.x.start * props.gridScaleX}
        y={props.grid.origin.y.start * props.gridScaleY}
        width={props.grid.origin.x.length * props.gridScaleX}
        height={props.grid.origin.y.length * props.gridScaleY}
        strokeWidth={0}
        draggable={props.selected}
        listening={false}
      />

      <Rect
        ref={shapeRef}
        fill={"transparent"}
        x={props.grid.origin.x.start * props.gridScaleX}
        y={props.grid.origin.y.start * props.gridScaleY}
        width={props.grid.origin.x.length * props.gridScaleX}
        height={props.grid.origin.y.length * props.gridScaleY}
        strokeWidth={Math.max(0.1, 2 / props.stageScale)}
        stroke={props.grid.color || "darkblue"}
        draggable={props.selected}
        listening={!props.grid.locked}
        draggableCursor="move"
        onTap={(e) => {
          props.selectGrid(props.i);
        }}
        onClick={(e) => {
          props.selectGrid(props.i);
        }}
        onDragEnd={(e) => {
          props.updateGrid(e, props.i, false);
        }}
      />

      {props.selected && (
        <Transformer
          ref={trRef}
          onTransformEnd={(e) => {
            const node = trRef.current.nodes()[0];
            const scaleX = node.scaleX();
            const scaleY = node.scaleY();
            const newWidth = node.width() * scaleX;
            const newHeight = node.height() * scaleY;
            const newRotation = node.rotation();
            node.scaleX(1);
            node.scaleY(1);
            props.updateGrid(e, props.i, true, newWidth, newHeight, newRotation);
          }}
        />
      )}
    </Layer>
  ) : null;
} 